import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import HeatBoard from "@/pages/home/components/HeatBoard";
import ExpressFeed from "@/pages/home/components/ExpressFeed";
import TopicCollection from "@/pages/home/components/TopicCollection";
import InsiderZone from "@/pages/home/components/InsiderZone";
import SubmitChannel from "@/pages/home/components/SubmitChannel";
import QuoteBand from "@/pages/home/components/QuoteBand";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <HeatBoard />
        <ExpressFeed />
        <QuoteBand />
        <TopicCollection />
        <InsiderZone />
        <SubmitChannel />
      </main>
      <Footer />
    </div>
  );
}